<script lang="ts" setup>
import { computed, toRefs } from 'vue';
import { useDateTime } from '@/composables';

interface Props {
  title: string;
  name: string;
  dates: Date | string[];
}

const props = withDefaults(defineProps<Props>(), {
  title: null,
  name: '',
  dates: () => [] || '',
});

const { title, name, dates } = toRefs(props);

const subject: string = computed(() => `${title.value} Report for ${name.value}`);

const formattedDates: string = computed(() => {
  if (dates.value instanceof Array) {
    const start = useDateTime().formatDateShortMonth(dates.value[0]);
    const end = useDateTime().formatDateShortMonth(dates.value[1]);
    return dates.value.length > 0 ? `${start} to ${end}` : '';
  }

  return useDateTime().formatDateShortMonth(dates.value);
});
</script>

<template>
  <div class="flex flex-wrap gap-2 p-2">
    <h2>{{ subject }}</h2>
    <p class="font-normal text-color-secondary pt-1">{{ formattedDates }}</p>
  </div>
</template>
